import React, { useState } from 'react';
import '../../Assets/Css/Header.css';
import logo from '../../Assets/Images/PrinceLogo.svg';
import menuIcon from '../../Assets/Images/MenuIcon.svg'; 
import closeIcon from '../../Assets/Images/crossIcon.svg'; 

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to handle smooth scrolling
  const handleSmoothScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth', // Smooth scroll effect
        block: 'start', // Align to the top of the section
      });
    }
    setIsMenuOpen(false); // Close the menu after clicking a link (for mobile)
  };

  return (
    <header className="header">
      <div className="logo-row">
        <img src={logo} alt="Prince Logo" className="header-logo" />
        <img 
          src={isMenuOpen ? closeIcon : menuIcon} // Toggle between menu and close icons
          alt={isMenuOpen ? "Close Menu" : "Open Menu"} 
          className="menu-icon" 
          onClick={toggleMenu}
        />
      </div>
      <nav className={`nav-row ${isMenuOpen ? 'open' : ''}`}>
        <a 
          href="#home" 
          className="nav-link active" 
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            handleSmoothScroll('home');
          }}
        >
          Home
        </a>
        <a 
          href="#about" 
          className="nav-link" 
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            handleSmoothScroll('about');
          }}
        >
          About Us
        </a>
        <a 
          href="#productions" 
          className="nav-link" 
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            handleSmoothScroll('productions');
          }}
        >
          Our Productions
        </a>
        <a 
          href="#news" 
          className="nav-link" 
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            handleSmoothScroll('news');
          }}
        >
          News & Updates
        </a>
        <a 
          href="#contact" 
          className="nav-link" 
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            handleSmoothScroll('contact');
          }}
        >
          Contact Us
        </a>
      </nav>
    </header>
  );
};

export default Header;